import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as RewardService from '_services/rewards-service';

const initialState = {
  rewards: null,
  selectedReward: null,
  postedImage: null,      // image from create reward
  imageStatus: 'idle',
  status: 'idle',
  error: null,
  deletedStatus: 'idle'
};

// fetch prm club data
export const fetchRewards = createAsyncThunk('rewards/fetchRewards', async (iata) => {
  return RewardService.getAirportRewards(iata);
});

//fetch products by retailer id
export const fetchProductsByRetailerId = createAsyncThunk('rewards/fetchProductsByRetailerId', async (id) => {
  return RewardService.getProductsByRetailerId(id);
});
// post prm club data
export const postReward = createAsyncThunk('rewards/postReward', async (reward) => {
  return RewardService.postReward(reward);
});

// edit prm club data
export const editReward = createAsyncThunk('rewards/editReward', async (reward) => {
  return RewardService.editReward(reward);
});

// delete prm club data
export const deleteReward = createAsyncThunk('rewards/deleteReward', async (reward) => {
  return RewardService.deleteReward(reward);
});

// upload image when creating reward
export const uploadImage = createAsyncThunk('rewards/uploadImage', async (image) => {
  return RewardService.UploadImage(image);
});

const rewardsSlice = createSlice({
  name: 'rewards',
  initialState,
  reducers: {
    reset: (state) => {
      return initialState
    },
    setSelectedReward: (state, action) => {
      return {
        ...state,
        selectedReward: action.payload,
        status: 'rewarded',
        error: null,
      }
    },
    setPostedImage: (state, action) => {
      return {
        ...state,
        postedImage: action.payload,
        imageStatus: 'succeeded',
      }
    },
  },
  extraReducers: {
    [fetchRewards.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
      }
    },
    [fetchRewards.fulfilled]: (state, action) => {
      action.payload.forEach((reward, index) => {
        action.payload[index].photo = decodeHtml(htmlDecode(reward.photo));
      });
      return {
        ...state,
        status: 'succeeded',
        rewards: action.payload,
      }
    },
    [fetchRewards.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message,
      }
    },
    [fetchProductsByRetailerId.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
      }
    },
    [fetchProductsByRetailerId.fulfilled]: (state, action) => {
      action.payload.forEach((reward, index) => {
        action.payload[index].photo = decodeHtml(htmlDecode(reward.photo));
      });
      return {
        ...state,
        status: 'succeeded',
        rewards: action.payload,
      }
    },
    [fetchProductsByRetailerId.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message,
      }
    },
    [postReward.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
      }
    },
    [postReward.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
      }
    },
    [postReward.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message,
      }
    },
    [uploadImage.pending]: (state, action) => {
      return {
        ...state,
        imageStatus: 'loading',
      }
    },
    [uploadImage.fulfilled]: (state, action) => {
      return {
        ...state,
        imageStatus: 'succeeded',
        postedImage: action.payload,
      }
    },
    [uploadImage.rejected]: (state, action) => {
      return {
        ...state,
        imageStatus: 'failed',
        error: action.error.message
      }
    },
    [editReward.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
      }
    },
    [editReward.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        selectedReward: action.payload,
      }
    },
    [editReward.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message
      }
    },
    [deleteReward.pending]: (state, action) => {
      return {
        ...state,
        deletedStatus: 'loading',
      }
    },
    [deleteReward.fulfilled]: (state, action) => {
      return {
        ...state,
        deletedStatus: 'succeeded',
      }
    },
    [deleteReward.rejected]: (state, action) => {
      return {
        ...state,
        deletedStatus: 'failed',
        error: action.error.messag,
      }
    },

  }
});

// select prm shop rewards
export const selectPRMRewards = (state) => {

  if (state.rewards.rewards == null) { return [] }
  if (state.rewards.rewards == undefined) { return [] }

  let list = [];

  state.rewards.rewards.forEach(reward => {
    if (reward.category == 'EXCLUSIVE') {
      list.push(reward)
    }
  });

  return list;

}


export const { reset, setSelectedReward, setPostedImage } = rewardsSlice.actions;
export const selectRewards = state => state.rewards.rewards;
export const selectRewardsStatus = state => state.rewards.status;
export const selectedReward = state => state.rewards.selectReward;
export const selectSelectedReward = (state) => state.rewards.selectedReward;
export const selectPostedImage = state => state.rewards.postedImage;
export const selectImageStatus = state => state.rewards.imageStatus;
export const selectDeletedStatus = state => state.rewards.deletedStatus;
export default rewardsSlice.reducer;

function htmlDecode(input) {
  var doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
}

function decodeHtml(html) {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}
